export default "__VITE_ASSET__6Z9bLhncN5znScBEgEzgkw__"